export function isWechat() {
  if (typeof window !== 'undefined') {
    return /MicroMessenger/i.test(window.navigator.userAgent);
  }
  return false;
}

const APP_UA_PATTERNS = [
  /(packageName_|bundleName_)?com\.luqifei\.deerbook(?:\.har)?\b/i,
  /(packageName_|bundleName_)?com\.modengxian\.huiyabook(?:\.har)?\b/i,
];

const APP_UA_HINT_PATTERNS = [
  /\bpackageName_[^\s]+/i,
  /\bbundleName_[^\s]+/i,
  /\bversion_[\d.]+/i,
  /\bchannel_[^\s]+/i,
  /\btype_(android|ios|ohos)\b/i,
];

export function getUserAgent() {
  if (typeof window === 'undefined') {
    return '';
  }
  return navigator.userAgent || '';
}

export function getAppVersionFromUserAgent() {
  const userAgent = getUserAgent();
  const versionMatch = userAgent.match(/version_([\d.]+)/i);
  return versionMatch ? versionMatch[1] : '';
}

export function isPadApp() {
  const userAgent = getUserAgent();
  return isApp() && /(?:^|\s)pad_true(?:\s|$)/i.test(userAgent);
}

export function hasNativeAppInitBridge() {
  if (typeof window === 'undefined') {
    return false;
  }
  return typeof window.Luqifei?.appInitCallback === 'function';
}

export function hasInAppQueryParam() {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get('inApp') === '1';
  } catch (_) {
    return false;
  }
}

export function hasAppUserAgentSignature() {
  const userAgent = getUserAgent();
  if (!userAgent) {
    return false;
  }
  if (APP_UA_PATTERNS.some((pattern) => pattern.test(userAgent))) {
    return true;
  }
  return (
    APP_UA_HINT_PATTERNS.every((pattern) => pattern.test(userAgent)) &&
    /(deerbook|huiyabook)/i.test(userAgent)
  );
}

export function isApp() {
  if (typeof window === 'undefined') return false;
  if (hasNativeAppInitBridge()) return true;
  if (hasAppUserAgentSignature()) return true;
  if (hasInAppQueryParam()) return true;
  return false;
}

export function compareVersion(version1: string, version2: string): boolean {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  const length = Math.max(v1Parts.length, v2Parts.length);

  for (let i = 0; i < length; i++) {
    const v1 = v1Parts[i] || 0; // 若不存在则用 0 代替
    const v2 = v2Parts[i] || 0; 

    if (v1 > v2) {
      return true;
    } else if (v1 < v2) {
      return false;
    }
  }

  return true; // 相等时返回 true
}
